import Typography from '@mui/material/Typography';
const FormHead = ({ headText, required ,sx}) => {
    return (
      <>
         <Typography variant="subtitle1" gutterBottom>
          <span
            style={{
              ...sx,
            fontWeight:'bold',
              paddingBottom: "3px",
              color:'rgba(48, 51, 107,1.0)'
            }}
          >
            {headText}
          </span>
          {required && <span style={{ color: "red" }}>*</span>}:
        </Typography>
      </>
    );
  };
  export default FormHead;
  